// src/App.js
import { useEffect, useState } from "react";
import { supabase } from "./pages/supabaseClient";

import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Clockins from "./pages/Clockins";
import ZReport from "./pages/ZReport";
import ZReportNext from "./pages/ZReportNext";
import ZReport_Advanced from "./pages/ZReport_Advanced";
import Suppliers from "./pages/Suppliers"
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Wastage from "./pages/Wastage";
import Expenses from "./pages/Expenses";
import Debts from "./pages/Debts";
import Rota from "./pages/Rota";
import RotaAdmin from "./pages/RotaAdmin";
import StaffRota from "./pages/StaffRota";

import Sidebar from "./components/Sidebar";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AutoButtonVariants from "./components/AutoButtonVariants";

export default function App() {
  const [page, setPage] = useState("Clockins");
  const [user, setUser] = useState(null);
  const [isResetPassword, setIsResetPassword] = useState(false);

  // role
  const [role, setRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);
  if (window.location.pathname === "/auth/reset-password") {
    return <ResetPassword onComplete={() => window.location.href = "/login"} />;
  }
  // auth state
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user || null);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user || null);
      if (event === "PASSWORD_RECOVERY") setIsResetPassword(true);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  // load role
  useEffect(() => {
    (async () => {
      if (!user?.id) {
        setRole(null);
        setRoleLoading(false);
        return;
      }
      setRoleLoading(true);
      const { data, error } = await supabase
        .from("employees")
        .select("role")
        .eq("id", user.id)
        .maybeSingle();
      setRole(!error ? data?.role ?? null : null);
      setRoleLoading(false);
    })();
  }, [user?.id]);

  if (isResetPassword) return <ResetPassword onComplete={() => setIsResetPassword(false)} />;
  if (!user) return <Login onLogin={(u) => setUser(u)} />;

  const canAdmin = role === "admin" || role === "manager";

  const renderPage = () => {
    switch (page) {
      case "Clockins":
        return <Clockins />;
      case "ZReport":
        return <ZReport />;
         case "ZReportNext":
        return <ZReportNext />;
      case "ZReport_Advanced":
        return <ZReport_Advanced />;
        case "Suppliers":
        return <Suppliers/>;
      case "Dashboard":
        return <Dashboard />;
      case "Admin":
        if (roleLoading) return <div style={{ padding: 16 }}>Checking access…</div>;
        return canAdmin ? <Admin /> : <div style={{ padding: 16, color: "crimson" }}>Access denied</div>;
      case "Wastage":
        return <Wastage />;
      case "Expenses":
        return <Expenses />;
      case "Debts":
        return <Debts />;
      default:
        return <Clockins />;
        case "Rota":
        return <Rota />;
        case "RotaAdmin":
        return <RotaAdmin />;
         case "StaffRota":
        return <StaffRota />;
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar
        page={page}
        onNavigate={(key) => setPage(key)}
        userName={user?.user_metadata?.display_name || user?.email}
        onLogout={() => supabase.auth.signOut()}
        canAdmin={canAdmin}
        userRole={role} 
      />

      <main className="main-content" style={{ flex: 1, padding: 16 }}>
  <AutoButtonVariants />
  {renderPage()}
</main>

      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
    </div>
  );
}
